import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const businessRoutes: RouteRecordRaw[] = [
  {
    path: '/business',
    name: 'Business',
    component: Layout,
    meta: {
      title: '商城交易',
      icon: 'mdi-store',
      requiresAuth: true
    },
    children: [
      {
        path: 'info',
        name: 'BusinessInfo',
        component: getParentLayout(),
        meta: {
          title: '服务商',
          icon: 'mdi-account-group',
          alwaysShow: true,
          hidden: true
        },
        children: [
          {
            path: 'list',
            name: 'BusinessList',
            component: () => import('@/views/Admin/Business/Info/List.vue'),
            meta: { title: '列表' }
          }
        ]
      },
      {
        path: 'shop',
        name: 'BusinessShop',
        component: getParentLayout(),
        meta: { title: '商城管理', icon: 'mdi-store-outline', alwaysShow: true },
        children: [
          {
            path: 'stores',
            name: 'ShopStores',
            component: () => import('@/views/Admin/Business/Shop/Shop.vue'),
            meta: { title: '店铺管理', icon: 'mdi-storefront' }
          },
          {
            path: 'types',
            name: 'ShopTypes',
            component: () => import('@/views/Admin/Business/Shop/Types.vue'),
            meta: { title: '商品类别', icon: 'mdi-shape-outline' }
          },
          {
            path: 'category',
            name: 'ShopCategory',
            component: () => import('@/views/Admin/Business/Shop/Category.vue'),
            meta: { title: '商品分类', icon: 'mdi-tag-multiple-outline' }
          },
          {
            path: 'goods-source',
            name: 'ShopGoodsSource',
            component: () => import('@/views/Admin/Business/Shop/GoodsSource.vue'),
            meta: { title: '商品来源', icon: 'mdi-source-branch' }
          },
          {
            path: 'products',
            name: 'ShopProducts',
            component: () => import('@/views/Admin/Business/Shop/Goods.vue'),
            meta: { title: '商品管理', icon: 'mdi-package-variant-closed' }
          },
          {
            path: 'orders',
            name: 'ShopOrders',
            component: () => import('@/views/Admin/Business/Shop/Orders.vue'),
            meta: { title: '订单管理', icon: 'mdi-clipboard-list-outline' }
          },
          {
            path: 'logistics',
            name: 'ShopLogisticsTracking',
            component: () => import('@/views/Admin/Business/Shop/LogisticsTracking.vue'),
            meta: { title: '物流跟踪', icon: 'mdi-truck-fast-outline' }
          }
        ]
      },
      {
        path: 'supply-chain',
        name: 'BusinessSupplyChain',
        component: getParentLayout(),
        meta: {
          title: '供应链管理',
          icon: 'mdi-truck-delivery-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'supplier',
            name: 'SupplyChainSupplier',
            component: () => import('@/views/Admin/Business/SupplyChain/Supplier.vue'),
            meta: { title: '供应商信息', icon: 'mdi-account-tie-outline' }
          },
          {
            path: 'supplier-api',
            name: 'SupplyChainSupplierApi',
            component: () => import('@/views/Admin/Business/SupplyChain/SupplierApi.vue'),
            meta: { title: '供应商API', icon: 'mdi-api' }
          },
          {
            path: 'logistics-settings',
            name: 'SupplyChainLogisticsSettings',
            component: () => import('@/views/Admin/Business/SupplyChain/LogisticsSettings.vue'),
            meta: { title: '物流设置', icon: 'mdi-truck-outline' }
          },
          {
            path: 'supplier-goods',
            name: 'SupplyChainSupplierGoods',
            component: () => import('@/views/Admin/Business/SupplyChain/SupplierGoods.vue'),
            meta: { title: '供应商商品', icon: 'mdi-package-variant-closed', noCache: true }
          },
          {
            path: 'goods-audit',
            name: 'SupplyChainGoodsAudit',
            component: () => import('@/views/Admin/Business/SupplyChain/GoodsAudit.vue'),
            meta: { title: '商品审核', icon: 'mdi-clipboard-check-outline', noCache: true }
          }
        ]
      },
      {
        path: 'payment',
        name: 'FinancePayment',
        component: getParentLayout(),
        meta: { title: '支付方式管理', icon: 'mdi-credit-card-settings-outline', alwaysShow: true },
        children: [
          {
            path: 'list',
            name: 'FinancePaymentList',
            component: () => import('@/views/Admin/Finance/Payment/List.vue'),
            meta: { title: '支付方式列表' }
          },
          {
            path: 'channel',
            name: 'FinancePaymentChannelList',
            component: () => import('@/views/Admin/Finance/Payment/ChannelList.vue'),
            meta: { title: '支付渠道列表' }
          }
        ]
      },
      {
        path: 'merchant',
        name: 'BusinessMerchant',
        component: getParentLayout(),
        meta: { title: '实体商户', icon: 'mdi-storefront-outline', alwaysShow: true },
        children: [
          {
            path: 'list',
            name: 'BusinessMerchantList',
            component: () => import('@/views/Admin/Business/Merchant/List.vue'),
            meta: { title: '商户列表', icon: 'mdi-account-tie-outline' }
          },
          {
            path: 'money-log',
            name: 'BusinessMerchantMoneyLog',
            component: () => import('@/views/Admin/Business/Merchant/MoneyLog.vue'),
            meta: { title: '资金日志', icon: 'mdi-currency-usd' }
          },
          {
            path: 'shop-apply',
            name: 'BusinessMerchantShopApply',
            component: () => import('@/views/Admin/Business/Merchant/ShopApply.vue'),
            meta: { title: '开店申请审核', icon: 'mdi-clipboard-check-outline' }
          },
          {
            path: 'shop-audit',
            name: 'BusinessMerchantShopAudit',
            component: () => import('@/views/Admin/Business/Merchant/ShopAudit.vue'),
            meta: { title: '店铺审核', icon: 'mdi-store-check-outline' }
          },
          {
            path: 'goods-audit',
            name: 'BusinessMerchantGoodsAudit',
            component: () => import('@/views/Admin/Business/Merchant/GoodsAudit.vue'),
            meta: { title: '自营商品审核', icon: 'mdi-package-check' }
          },
          {
            path: 'card-types',
            name: 'BusinessMerchantCardTypes',
            component: () => import('@/views/Admin/Business/Merchant/CardTypes.vue'),
            meta: { title: '卡片类型', icon: 'mdi-card-bulleted-outline' }
          },
          {
            path: 'card-list',
            name: 'BusinessMerchantCardList',
            component: () => import('@/views/Admin/Business/Merchant/CardList.vue'),
            meta: { title: '卡片审核', icon: 'mdi-card-account-details-outline' }
          },
          {
            path: 'card-log',
            name: 'BusinessMerchantCardLog',
            component: () => import('@/views/Admin/Business/Merchant/CardLog.vue'),
            meta: { title: '兑换核销记录', icon: 'mdi-clipboard-text-clock-outline' }
          }
        ]
      },
      {
        path: 'partners',
        name: 'BusinessPartners',
        component: getParentLayout(),
        meta: { title: '经销商', icon: 'mdi-store-outline', alwaysShow: true, hidden: true },
        children: [
          {
            path: 'stores',
            name: 'PartnerStores',
            component: () => import('@/views/Admin/Business/Partner/Shop.vue'),
            meta: { title: '店铺' }
          },
          {
            path: 'products',
            name: 'PartnerProducts',
            component: () => import('@/views/Admin/Business/Partner/Goods.vue'),
            meta: { title: '选品' }
          },
          {
            path: 'orders',
            name: 'PartnerOrders',
            component: () => import('@/views/Admin/Business/Partner/Orders.vue'),
            meta: { title: '订单收益' }
          },
          {
            path: 'rewards',
            name: 'PartnerRewards',
            component: () => import('@/views/Admin/Business/Partner/RewardConfig.vue'),
            meta: { title: '业绩配置' }
          },
          {
            path: 'report',
            name: 'PartnerReport',
            component: () => import('@/views/Admin/Business/Partner/Report.vue'),
            meta: { title: '报表' }
          }
        ]
      },
      {
        path: 'coin',
        name: 'BusinessCoin',
        component: getParentLayout(),
        meta: { title: '币种管理', icon: 'mdi-bitcoin', alwaysShow: true, hidden: true },
        children: [
          {
            path: 'list',
            name: 'CoinList',
            component: () => import('@/views/Admin/Business/Coin/Index.vue'),
            meta: { title: '币种列表' }
          }
        ]
      }
    ]
  }
]

export default businessRoutes
